import React from "react";

const DocIcon = (props: any) => {
  return (
    <svg width={70} height={71} fill="none" {...props}>
      <path
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
        d="M43.75 66.353h-17.5c-7.862 0-13.353-1.681-16.888-5.217-3.535-3.535-5.216-9.026-5.216-16.887v-17.5c0-7.862 1.68-13.353 5.216-16.888 3.535-3.535 9.026-5.216 16.888-5.216h14.583c.92 0 1.688.767 1.688 1.687s-.768 1.688-1.688 1.688H26.25c-6.759 0-11.489 1.196-14.51 4.218-3.023 3.022-4.22 7.753-4.22 14.51v17.5c0 6.759 1.197 11.49 4.22 14.511 3.021 3.022 7.751 4.219 14.51 4.219h17.5c6.758 0 11.488-1.197 14.51-4.219 3.022-3.022 4.219-7.752 4.219-14.51V29.665c0-.92.768-1.687 1.687-1.687.92 0 1.688.768 1.688 1.687V44.25c0 7.861-1.681 13.352-5.217 16.887-3.535 3.535-9.026 5.217-16.887 5.217Z"
      />
      <path
        fill="var(--color-stroke-active)"
        stroke="var(--color-stroke-active)"
        d="m40.17 4.785.007-.003.007-.003c.616-.264 1.337-.118 1.846.365l23.329 23.329a1.69 1.69 0 0 1-1.192 2.88H52.5c-4.942 0-8.239-.965-10.315-3.04-2.075-2.076-3.04-5.373-3.04-10.315V6.332c0-.682.41-1.306 1.025-1.547Zm3.204 6.472-.854-.853V17.998c0 3.763.478 6.328 2.065 7.915 1.587 1.587 4.152 2.064 7.915 2.064H60.094l-.853-.853-15.867-15.867Z"
      />
      <path
        fill="var(--color-stroke-active)"
        d="M37.917 40.605h-17.5a2.203 2.203 0 0 1-2.188-2.187c0-1.196.992-2.188 2.188-2.188h17.5c1.196 0 2.188.992 2.188 2.188a2.203 2.203 0 0 1-2.188 2.188ZM32.084 52.27H20.417a2.203 2.203 0 0 1-2.188-2.188c0-1.196.992-2.188 2.188-2.188h11.667c1.195 0 2.187.992 2.187 2.188a2.203 2.203 0 0 1-2.187 2.188Z"
      />
    </svg>
  );
};

export default DocIcon;
